function setCookie(name, value, days) {
	var expires = '';
	if (days) {
		var date = new Date();
		date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
		expires = '; expires=' + date.toUTCString();
	}
	document.cookie = name + '=' + (value || '') + expires + '; path=/';
}

function getCookie(name) {
	var nameEQ = name + '=';
	var ca = document.cookie.split(';');
	for (var i = 0; i < ca.length; i++) {
		var c = ca[i];
		while (c.charAt(0) == ' ') c = c.substring(1, c.length);
		if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
	}
	return null;
}

function toggleDarkMode(state) {
	var body = document.body;
	if (state === 'DARK') {
		body.classList.add('dark-mode');
		setCookie('darkmode', 'true', 3000);
	} else {
		body.classList.remove('dark-mode');
		setCookie('darkmode', null, 3000);
	}
}

function toggleDarkModeGallery(state) {
	var body = document.body;
	if (state === 'DARK') {
		setCookie('darkmode', null, 3000);
		body.classList.remove('dark-mode');
		body.classList.remove('all-mode');
	} else if (state === 'ALL') {
		body.classList.add('all-mode');
		body.classList.remove('dark-mode');
	} else {
		setCookie('darkmode', 'true', 3000);
		body.classList.add('dark-mode');
		body.classList.remove('all-mode');
	}
}

function toggleMenu() {
	var menuListContainer = document.getElementById('menu-list-container');
	menuListContainer.classList.toggle('visually-hidden');
    var menuList = document.getElementById('menu-list');
	menuList.classList.toggle('visually-hidden');
}

(function () {
    // duplicate: true causes memory leak: https://github.com/mazedigital/Web-Ticker/issues/50
    // duplicate the text in-place instead
	$('#webTicker').webTicker({
		duplicate: false,
		rssfrequency: 0,
		startEmpty: false,
		hoverpause: false,
	});

	// var switchHeaderDarkMode = document.get('switch-header');
	// switchHeaderDarkMode.addEventListener('change', toggleDarkMode, false);

	function darkModeToggler() {
		var body = document.body;
		if (getCookie('darkmode') === 'true') {
			body.classList.remove('dark-mode');
			setCookie('darkmode', null, 3000);
		} else {
			body.classList.add('dark-mode');
			setCookie('darkmode', 'true', 3000);
		}
	}

	var switchDarkMode = document.getElementsByClassName('switch');
	var switchCheckBoxDarkMode = document.getElementsByClassName('switch-checkbox');
    /*
	switchDarkMode[0].addEventListener('change', darkModeToggler, false);
	if (switchDarkMode.length > 1) {
		switchDarkMode[1].addEventListener('change', darkModeToggler, false);
	}
    */
	var menuToggler = document.getElementById('menu-container');
    var mobileClose = document.getElementById('mobile-close-btn')
    mobileClose.addEventListener('click', toggleMenu, false);
	menuToggler.addEventListener('click', toggleMenu, false);
/*
	if (getCookie('darkmode') === 'true') {
		switchCheckBoxDarkMode[0].checked = false;
		if (switchDarkMode.length > 1) switchCheckBoxDarkMode[1].checked = false;
		toggleDarkMode('DARK');
	} else {
		switchCheckBoxDarkMode[0].checked = true;
		if (switchDarkMode.length > 1) switchCheckBoxDarkMode[1].checked = true;
		toggleDarkMode('NOTDARK');
	}
  */
})();
